export type FacebookShareDisplayMode = 'popup' | 'touch';

const defaultFacebookAppId = '954504137471896';

type WebExternalShareContext = {
  displayModeStandalone?: boolean;
  maxTouchPoints?: number;
  platformOS: string;
  standalone?: boolean;
  userAgent?: string;
  viewportWidth?: number;
};

const mobileUserAgentPattern =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i;

export function shouldUseSameWindowExternalShare({
  displayModeStandalone = false,
  maxTouchPoints = 0,
  platformOS,
  standalone = false,
  userAgent = '',
  viewportWidth,
}: WebExternalShareContext) {
  if (platformOS !== 'web') {
    return false;
  }

  if (standalone || displayModeStandalone) {
    return true;
  }

  if (mobileUserAgentPattern.test(userAgent)) {
    return true;
  }

  const isTouchTablet =
    maxTouchPoints > 1 && typeof viewportWidth === 'number' && viewportWidth <= 1024;

  return isTouchTablet;
}

export function buildFacebookShareUrl({
  appId = defaultFacebookAppId,
  display = 'popup',
  redirectUrl,
  url,
}: {
  appId?: string;
  display?: FacebookShareDisplayMode;
  redirectUrl?: string;
  url: string;
}) {
  const facebookUrl = new URL('https://www.facebook.com/dialog/share');

  facebookUrl.searchParams.set('app_id', appId);
  facebookUrl.searchParams.set('display', display);
  facebookUrl.searchParams.set('href', url);
  facebookUrl.searchParams.set('redirect_uri', redirectUrl ?? url);
  return facebookUrl.toString();
}
